import React from "react";
import { Box, Typography, Select, MenuItem } from "@mui/material";

function humanizeLabel(key) {
  if (!key) return "";
  return key
    .toString()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function FieldBoolean({ name, schema = {}, value, onChange }) {
  const description = schema.description;
  const current = value === true ? "true" : value === false ? "false" : "";

  const handleChange = (e) => {
    const v = e.target.value;
    let boolVal;
    if (v === "true") boolVal = true;
    else if (v === "false") boolVal = false;
    else boolVal = undefined; // allow clearing
    if (onChange) onChange(boolVal);
  };

  return (
    <Box mb={1} sx={{ maxWidth: 360 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {humanizeLabel(name)}:
        </Typography>
        <Select
          value={current}
          onChange={handleChange}
          size="small"
          displayEmpty
          sx={{ height: 42 }}
          inputProps={{ "aria-label": humanizeLabel(name) }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value="true">True</MenuItem>
          <MenuItem value="false">False</MenuItem>
        </Select>
      </Box>
    </Box>
  );
}
